import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';
import { CloseButton } from '~/components/common/modal/CloseButton';
import { CommonBasicModal } from '~/components/common/modal/CommonBasicModal';
import { pxVw } from '~/styles/ts/functions';

const BlackButtonPosition = styled.div`
  position: absolute;
  top: ${pxVw.SP(32)};
  right: ${pxVw.SP(32)};
`;

type Props = ComponentPropsWithoutRef<typeof CommonBasicModal>;

export const CommonPlaneModal = ({ size, children, onClick }: Props) => {
  return (
    <CommonBasicModal size={size} onClick={onClick}>
      <>
        {children}
        <BlackButtonPosition>
          <CloseButton onClick={onClick} strokeColor={'primary'} />
        </BlackButtonPosition>
      </>
    </CommonBasicModal>
  );
};
